	/*! vimeo-jquery-api 2016-05-05 */
	!function(a,b){var c={catchMethods:{methodreturn:[],count:0},init:function(b){var c,d,e;b.originalEvent.origin.match(/vimeo/gi)&&"data"in b.originalEvent&&(e="string"===a.type(b.originalEvent.data)?a.parseJSON(b.originalEvent.data):b.originalEvent.data,e&&(c=this.setPlayerID(e),c.length&&(d=this.setVimeoAPIurl(c),e.hasOwnProperty("event")&&this.handleEvent(e,c,d),e.hasOwnProperty("method")&&this.handleMethod(e,c,d))))},setPlayerID:function(b){return a("iframe[src*="+b.player_id+"]")},setVimeoAPIurl:function(a){return"http"!==a.attr("src").substr(0,4)?"https:"+a.attr("src").split("?")[0]:a.attr("src").split("?")[0]},handleMethod:function(a){this.catchMethods.methodreturn.push(a.value)},handleEvent:function(b,c,d){switch(b.event.toLowerCase()){case"ready":for(var e in a._data(c[0],"events"))e.match(/loadProgress|playProgress|play|pause|finish|seek|cuechange/)&&c[0].contentWindow.postMessage(JSON.stringify({method:"addEventListener",value:e}),d);if(c.data("vimeoAPICall")){for(var f=c.data("vimeoAPICall"),g=0;g<f.length;g++)c[0].contentWindow.postMessage(JSON.stringify(f[g].message),f[g].api);c.removeData("vimeoAPICall")}c.data("vimeoReady",!0),c.triggerHandler("ready");break;case"seek":c.triggerHandler("seek",[b.data]);break;case"loadprogress":c.triggerHandler("loadProgress",[b.data]);break;case"playprogress":c.triggerHandler("playProgress",[b.data]);break;case"pause":c.triggerHandler("pause");break;case"finish":c.triggerHandler("finish");break;case"play":c.triggerHandler("play");break;case"cuechange":c.triggerHandler("cuechange")}}},d=a.fn.vimeoLoad=function(){var b=a(this).attr("src"),c=!1;if("https:"!==b.substr(0,6)&&(b="http"===b.substr(0,4)?"https"+b.substr(4):"https:"+b,c=!0),null===b.match(/player_id/g)){c=!0;var d=-1===b.indexOf("?")?"?":"&",e=a.param({api:1,player_id:"vvvvimeoVideo-"+Math.floor(1e7*Math.random()+1).toString()});b=b+d+e}return c&&a(this).attr("src",b),this};jQuery(document).ready(function(){a("iframe[src*='vimeo.com']").each(function(){d.call(this)})}),a(["loadProgress","playProgress","play","pause","finish","seek","cuechange"]).each(function(b,d){jQuery.event.special[d]={setup:function(){var b=a(this).attr("src");if(a(this).is("iframe")&&b.match(/vimeo/gi)){var e=a(this);if("undefined"!=typeof e.data("vimeoReady"))e[0].contentWindow.postMessage(JSON.stringify({method:"addEventListener",value:d}),c.setVimeoAPIurl(a(this)));else{var f="undefined"!=typeof e.data("vimeoAPICall")?e.data("vimeoAPICall"):[];f.push({message:d,api:c.setVimeoAPIurl(e)}),e.data("vimeoAPICall",f)}}}}}),a(b).on("message",function(a){c.init(a)}),a.vimeo=function(a,d,e){var f={},g=c.catchMethods.methodreturn.length;if("string"==typeof d&&(f.method=d),void 0!==typeof e&&"function"!=typeof e&&(f.value=e),a.is("iframe")&&f.hasOwnProperty("method"))if(a.data("vimeoReady"))a[0].contentWindow.postMessage(JSON.stringify(f),c.setVimeoAPIurl(a));else{var h=a.data("vimeoAPICall")?a.data("vimeoAPICall"):[];h.push({message:f,api:c.setVimeoAPIurl(a)}),a.data("vimeoAPICall",h)}return"get"!==d.toString().substr(0,3)&&"paused"!==d.toString()||"function"!=typeof e||(!function(a,d,e){var f=b.setInterval(function(){c.catchMethods.methodreturn.length!=a&&(b.clearInterval(f),d(c.catchMethods.methodreturn[e]))},10)}(g,e,c.catchMethods.count),c.catchMethods.count++),a},a.fn.vimeo=function(b,c){return a.vimeo(this,b,c)}}(jQuery,window);
	/* ScrollMagic v1.3.0 | (c) 2014 Jan Paepke (@janpaepke) | license & info: http://janpaepke.github.io/ScrollMagic */
	!function(e,t){if("function"==typeof define&&define.amd)define(["jquery","TweenMax","TimelineMax"],t);else{var n=t(e.jQuery,e.TweenMax,e.TimelineMax);e.ScrollMagic=n.Controller,e.ScrollScene=n.Scene}}(this,function(e,t,n){var r=function(t){var n,r,a="ScrollMagic",u={container:window,vertical:!0,globalSceneOptions:{},loglevel:2,refreshInterval:100},f=this,g=e.extend({},u,t),h=[],d=!1,p=0,v="PAUSED",w=!0,m=0,S=!0,E=function(){if(f.version=f.constructor.version,e.each(g,function(e){u.hasOwnProperty(e)||delete g[e]}),g.container=e(g.container).first(),0===g.container.length)throw a+" init failed.";w=!e.contains(document,g.container.get(0)),w||g.container.on("resize",function(e){e.stopPropagation()}),m=g.vertical?g.container.height():g.container.width(),g.container.on("scroll resize",b),g.refreshInterval=parseInt(g.refreshInterval),g.refreshInterval>0&&(r=window.setInterval(R,g.refreshInterval)),n=l(T)},F=function(){return g.vertical?g.container.scrollTop():g.container.scrollLeft()},y=function(e){g.vertical?g.container.scrollTop(e):g.container.scrollLeft(e)},T=function(){if(n=l(T),S&&d){var t=e.isArray(d)?d:h.slice(0),r=p;p=f.scrollPos();var i=p-r;v=0===i?"PAUSED":i>0?"FORWARD":"REVERSE",0>i&&t.reverse(),e.each(t,function(e,t){t.update(!0)}),0===t.length&&g.loglevel>=3,d=!1}},b=function(e){"resize"==e.type&&(m=g.vertical?g.container.height():g.container.width()),d=!0},R=function(){w||m!=(g.vertical?g.container.height():g.container.width())&&g.container.trigger("resize"),e.each(h,function(e,t){t.refresh()})},z=function(e){if(e.length<=1)return e;var t=e.slice(0);return t.sort(function(e,t){return e.scrollOffset()>t.scrollOffset()?1:-1}),t};return this.addScene=function(t){return e.isArray(t)?e.each(t,function(e,t){f.addScene(t)}):t instanceof i&&(t.parent()!=f?t.addTo(f):e.inArray(t,h)<0&&(h.push(t),h=z(h),t.on("shift."+a+"_sort",function(){h=z(h)}),e.each(g.globalSceneOptions,function(e,n){t[e]&&t[e].call(t,n)}))),f},this.removeScene=function(t){if(e.isArray(t))e.each(t,function(e,t){f.removeScene(t)});else{var n=e.inArray(t,h);n>-1&&(t.off("shift."+a+"_sort"),h.splice(n,1),t.remove())}return f},this.updateScene=function(t,n){return e.isArray(t)?e.each(t,function(e,t){f.updateScene(t,n)}):n?t.update(!0):(e.isArray(d)||(d=[]),-1==e.inArray(t,d)&&d.push(t),d=z(d)),f},this.update=function(e){return b({type:"resize"}),e&&T(),f},this.scrollTo=function(t){if(t instanceof i)t.parent()===f?f.scrollTo(t.scrollOffset()):log(2,"scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.",t);else if("string"===e.type(t)||s(t)||t instanceof e){var n=e(t).first();if(n[0]){var r=g.vertical?"top":"left",a=o(g.container),l=o(n);w||(a[r]-=f.scrollPos()),f.scrollTo(l[r]-a[r])}else log(2,"scrollTo(): The supplied element could not be found. Scroll cancelled.",t)}else e.isFunction(t)?y=t:y.call(g.container[0],t);return f},this.scrollPos=function(t){return arguments.length?(e.isFunction(t)&&(F=t),f):F.call(f)},this.info=function(e){var t={size:m,vertical:g.vertical,scrollPos:p,scrollDirection:v,container:g.container,isDocument:w};return arguments.length?void 0!==t[e]?t[e]:void 0:t},this.loglevel=function(e){return arguments.length?(g.loglevel!=e&&(g.loglevel=e),f):g.loglevel},this.enabled=function(e){return arguments.length?(S!=e&&(S=!!e,f.updateScene(h,!0)),f):S},this.destroy=function(e){window.clearTimeout(r);for(var t=h.length;t--;)h[t].destroy(e);return g.container.off("scroll resize",b),c(n),null},E(),f};r.version="1.3.0";var i=function(t){var i,s,l,c,u,f,g,h={onCenter:.5,onEnter:1,onLeave:0},d="ScrollScene",p={duration:0,offset:0,triggerElement:null,triggerHook:"onCenter",reverse:!0,tweenChanges:!1,loglevel:2},v=this,w=e.extend({},p,t),m="BEFORE",S=0,E={start:0,end:0},F=0,y=!0,T={unknownOptionSupplied:function(){e.each(w,function(e){p.hasOwnProperty(e)||delete w[e]})},duration:function(){if(e.isFunction(w.duration)){i=w.duration;try{w.duration=parseFloat(i())}catch(t){i=void 0,w.duration=p.duration}}else w.duration=parseFloat(w.duration),(!e.isNumeric(w.duration)||w.duration<0)&&(w.duration=p.duration)},offset:function(){w.offset=parseFloat(w.offset),e.isNumeric(w.offset)||(w.offset=p.offset)},triggerElement:function(){null!==w.triggerElement&&0===e(w.triggerElement).length&&(w.triggerElement=p.triggerElement)},triggerHook:function(){w.triggerHook in h||(w.triggerHook=e.isNumeric(w.triggerHook)?Math.max(0,Math.min(parseFloat(w.triggerHook),1)):p.triggerHook)},reverse:function(){w.reverse=!!w.reverse},tweenChanges:function(){w.tweenChanges=!!w.tweenChanges}},b=function(){R(),v.on("change.internal",function(e){"loglevel"!==e.what&&"tweenChanges"!==e.what&&("triggerElement"===e.what?x():"reverse"===e.what&&v.update())}).on("shift.internal",function(e){C(),v.update(),("AFTER"===m&&"duration"===e.reason||"DURING"===m&&0===w.duration)&&O()}).on("progress.internal",function(){P(),O()}).on("destroy",function(e){e.preventDefault()})},R=function(t){if(arguments.length)e.isArray(t)||(t=[t]);else{t=[];for(var n in T)t.push(n)}e.each(t,function(e,t){T[t]&&T[t]()})},z=function(e,t){var n=!1,r=w[e];return w[e]!=t&&(w[e]=t,R(e),n=r!=w[e]),n},C=function(){E={start:F+w.offset},s&&w.triggerElement&&(E.start-=s.info("size")*v.triggerHook()),E.end=E.start+w.duration},D=function(e){if(i){var t="duration";z(t,i.call(v))&&!e&&(v.trigger("change",{what:t,newval:w[t]}),v.trigger("shift",{reason:t}))}},x=function(t){var n=0;if(s&&w.triggerElement){for(var r=e(w.triggerElement).first(),i=s.info(),a=o(i.container),l=i.vertical?"top":"left";r.parent().data("ScrollMagicPinSpacer");)r=r.parent();var c=o(r);i.isDocument||(a[l]-=s.scrollPos()),n=c[l]-a[l]}var u=n!=F;F=n,u&&!t&&v.trigger("shift",{reason:"triggerElementPosition"})},P=function(e){if(l){var t=e>=0&&1>=e?e:S;if(-1===l.repeat())if("DURING"===m&&l.paused())l.play();else{if("DURING"===m||l.paused())return!1;l.pause()}else{if(t==l.progress())return!1;0===w.duration?"DURING"===m?l.play():l.reverse():w.tweenChanges?l.tweenTo(t*l.duration()):l.progress(t).pause()}return!0}return!1},O=function(e){if(c&&s){var t=s.info();if(e||"DURING"!==m){var n={position:u.inFlow?"relative":"absolute",top:0,left:0},r=c.css("position")!=n.position;u.pushFollowers?w.duration>0&&("AFTER"===m&&0===parseFloat(u.spacer.css("padding-top"))?r=!0:"BEFORE"===m&&0===parseFloat(u.spacer.css("padding-bottom"))&&(r=!0)):n[t.vertical?"top":"left"]=w.duration*S,c.css(n),r&&(c.removeClass(u.pinnedClass),A())}else{"fixed"!=c.css("position")&&(c.css("position","fixed"),A(),c.addClass(u.pinnedClass));var i=o(u.spacer,!0),a=w.reverse||0===w.duration?t.scrollPos-E.start:Math.round(S*w.duration*10)/10;i.top-=parseFloat(u.spacer.css("margin-top")),i[t.vertical?"top":"left"]+=a,c.css({top:i.top,left:i.left})}}},A=function(){if(c&&s&&u.inFlow){var t="AFTER"===m,n="BEFORE"===m,r="DURING"===m,i="fixed"==c.css("position"),o=s.info("vertical"),l=u.spacer.children().first(),f=a(u.spacer.css("display")),g={};f?(g["margin-top"]=n||r&&i?c.css("margin-top"):"auto",g["margin-bottom"]=t||r&&i?c.css("margin-bottom"):"auto"):g["margin-top"]=g["margin-bottom"]="auto",u.relSize.width||u.relSize.autoFullWidth?i?e(window).width()==u.spacer.parent().width()?c.css("width",u.relSize.autoFullWidth?"100%":"inherit"):c.css("width",u.spacer.width()):c.css("width","100%"):(g["min-width"]=l.outerWidth(!l.is(c)),g.width=i?g["min-width"]:"auto"),u.relSize.height?i?e(window).height()==u.spacer.parent().height()?c.css("height","inherit"):c.css("height",u.spacer.height()):c.css("height","100%"):(g["min-height"]=l.outerHeight(!f),g.height=i?g["min-height"]:"auto"),u.pushFollowers&&(g["padding"+(o?"Top":"Left")]=w.duration*S,g["padding"+(o?"Bottom":"Right")]=w.duration*(1-S)),u.spacer.css(g)}},I=function(){s&&c&&"DURING"===m&&!s.info("isDocument")&&O()},N=function(){s&&c&&"DURING"===m&&((u.relSize.width||u.relSize.autoFullWidth)&&e(window).width()!=u.spacer.parent().width()||u.relSize.height&&e(window).height()!=u.spacer.parent().height())&&A()},k=function(e){s&&c&&"DURING"===m&&!s.info("isDocument")&&(e.preventDefault(),s.scrollTo(s.info("scrollPos")-(e.originalEvent.wheelDelta/3||30*-e.originalEvent.detail)))};return this.parent=function(){return s},this.duration=function(t){var n="duration";return arguments.length?(e.isFunction(t)||(i=void 0),z(n,t)&&(v.trigger("change",{what:n,newval:w[n]}),v.trigger("shift",{reason:n})),v):w[n]},this.offset=function(e){var t="offset";return arguments.length?(z(t,e)&&(v.trigger("change",{what:t,newval:w[t]}),v.trigger("shift",{reason:t})),v):w[t]},this.triggerElement=function(e){var t="triggerElement";return arguments.length?(z(t,e)&&v.trigger("change",{what:t,newval:w[t]}),v):w[t]},this.triggerHook=function(t){var n="triggerHook";return arguments.length?(z(n,t)&&(v.trigger("change",{what:n,newval:w[n]}),v.trigger("shift",{reason:n})),v):e.isNumeric(w[n])?w[n]:h[w[n]]},this.reverse=function(e){var t="reverse";return arguments.length?(z(t,e)&&v.trigger("change",{what:t,newval:w[t]}),v):w[t]},this.tweenChanges=function(e){var t="tweenChanges";return arguments.length?(z(t,e)&&v.trigger("change",{what:t,newval:w[t]}),v):w[t]},this.loglevel=function(e){var t="loglevel";return arguments.length?(z(t,e)&&v.trigger("change",{what:t,newval:w[t]}),v):w[t]},this.state=function(){return m},this.triggerPosition=function(){var e=w.offset;return s&&(e+=w.triggerElement?F:s.info("size")*v.triggerHook()),e},this.triggerOffset=function(){return v.triggerPosition()},this.scrollOffset=function(){return E.start},this.update=function(e){if(s)if(e)if(s.enabled()&&y){var t,n=s.info("scrollPos");t=w.duration>0?(n-E.start)/(E.end-E.start):n>=E.start?1:0,v.trigger("update",{startPos:E.start,endPos:E.end,scrollPos:n}),v.progress(t)}else c&&"DURING"===m&&O(!0);else s.updateScene(v,!1);return v},this.refresh=function(){return D(),x(),v},this.progress=function(e){if(arguments.length){var t=!1,n=m,r=s?s.info("scrollDirection"):"PAUSED",i=w.reverse||e>=S;if(0===w.duration?(t=S!=e,S=1>e&&i?0:1,m=0===S?"BEFORE":"DURING"):0>=e&&"BEFORE"!==m&&i?(S=0,m="BEFORE",t=!0):e>0&&1>e&&i?(S=e,m="DURING",t=!0):e>=1&&"AFTER"!==m?(S=1,m="AFTER",t=!0):"DURING"!==m||i||O(),t){var o={progress:S,state:m,scrollDirection:r},a=m!=n,l=function(e){v.trigger(e,o)};a&&"DURING"!==n&&(l("enter"),l("BEFORE"===n?"start":"end")),l("progress"),a&&"DURING"!==m&&(l("BEFORE"===m?"start":"end"),l("leave"))}return v}return S},this.setTween=function(e){if(!n)return v;l&&v.removeTween();try{l=new n({smoothChildTiming:!0}).add(e).pause()}catch(t){}finally{e.repeat&&-1===e.repeat()&&(l.repeat(-1),l.yoyo(e.yoyo()))}return P(),v},this.removeTween=function(e){return l&&(e&&P(0),l.kill(),l=void 0),v},this.setPin=function(t,n){var r={pushFollowers:!0,spacerClass:"scrollmagic-pin-spacer",pinnedClass:""};if(n=e.extend({},r,n),t=e(t).first(),0===t.length)return v;if("fixed"==t.css("position"))return v;if(c){if(c===t)return v;v.removePin()}c=t,c.parent().hide();var i="absolute"!=c.css("position"),o=c.css(["display","top","left","bottom","right"]),s=c.css(["width","height"]);c.parent().show(),"0px"===s.width&&i&&a(o.display),!i&&n.pushFollowers&&(n.pushFollowers=!1);var l=e("<div></div>").addClass(n.spacerClass).css(o).data("ScrollMagicPinSpacer",!0).css({position:i?"relative":"absolute","margin-left":"auto","margin-right":"auto","box-sizing":"content-box"}),f=c[0].style;return u={spacer:l,relSize:{width:"%"===s.width.slice(-1),height:"%"===s.height.slice(-1),autoFullWidth:"0px"===s.width&&i&&a(o.display)},pushFollowers:n.pushFollowers,inFlow:i,origStyle:{width:f.width||"",position:f.position||"",top:f.top||"",left:f.left||"",bottom:f.bottom||"",right:f.right||"","box-sizing":f["box-sizing"]||"","-moz-box-sizing":f["-moz-box-sizing"]||"","-webkit-box-sizing":f["-webkit-box-sizing"]||""},pinnedClass:n.pinnedClass},u.relSize.width&&l.css("width",s.width),u.relSize.height&&l.css("height",s.height),c.before(l).appendTo(l).css({position:i?"relative":"absolute",top:"auto",left:"auto",bottom:"auto",right:"auto"}),(u.relSize.width||u.relSize.autoFullWidth)&&c.css("box-sizing","border-box"),e(window).on("scroll."+d+"_pin resize."+d+"_pin",I),c.on("mousewheel DOMMouseScroll",k),O(),v},this.removePin=function(t){return c&&(t||!s?(c.insertBefore(u.spacer).css(u.origStyle),u.spacer.remove()):"DURING"===m&&O(!0),e(window).off("scroll."+d+"_pin resize."+d+"_pin"),c.off("mousewheel DOMMouseScroll",k),c=void 0),v},this.setClassToggle=function(t,n){var r=e(t);return 0===r.length||"string"!==e.type(n)?v:(f=n,g=r,v.on("enter.internal_class leave.internal_class",function(e){g.toggleClass(f,"enter"===e.type)}),v)},this.removeClassToggle=function(e){return g&&e&&g.removeClass(f),v.off("start.internal_class end.internal_class"),f=void 0,g=void 0,v},this.addTo=function(e){return e instanceof r&&s!=e&&(s&&s.removeScene(v),s=e,R(),D(!0),x(!0),C(),A(),s.info("container").on("resize."+d,function(){N(),v.triggerHook()>0&&v.trigger("shift",{reason:"containerSize"})}),e.addScene(v),v.update()),v},this.enabled=function(e){return arguments.length?(y!=e&&(y=!!e,v.update(!0)),v):y},this.remove=function(){if(s){s.info("container").off("resize."+d);var e=s;s=void 0,e.removeScene(v)}return v},this.destroy=function(e){return v.removeTween(e),v.removePin(e),v.removeClassToggle(e),v.trigger("destroy",{reset:e}),v.remove(),v.off("start end enter leave progress change update shift destroy shift.internal change.internal progress.internal"),null},this.on=function(t,n){if(e.isFunction(n)){var r=e.trim(t).toLowerCase().replace(/(\w+)\.(\w+)/g,"$1."+d+"_$2").replace(/( |^)(\w+)(?= |$)/g,"$1$2."+d);e(v).on(r,n)}return v},this.off=function(t,n){var r=e.trim(t).toLowerCase().replace(/(\w+)\.(\w+)/g,"$1."+d+"_$2").replace(/( |^)(\w+)(?= |$)/g,"$1$2."+d+"$3");return e(v).off(r,n),v},this.trigger=function(t,n){var r=e.Event(e.trim(t).toLowerCase(),n);return e(v).trigger(r),v},b(),v},o=function(e,t){var n={top:0,left:0};if(e=e[0],e&&e.getBoundingClientRect){var r=e.getBoundingClientRect();n.top=r.top,n.left=r.left,t||(n.top+=(window.pageYOffset||document.scrollTop||0)-(document.clientTop||0),n.left+=(window.pageXOffset||document.scrollLeft||0)-(document.clientLeft||0))}return n},s=function(e){return"object"==typeof HTMLElement?e instanceof HTMLElement:e&&"object"==typeof e&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName},a=function(e){return["block","flex","list-item","table","-webkit-box"].indexOf(e)>-1},l=window.requestAnimationFrame,c=window.cancelAnimationFrame;return function(e){var t,n=0,r=["ms","moz","webkit","o"];for(t=0;!l&&t<r.length;++t)l=e[r[t]+"RequestAnimationFrame"],c=e[r[t]+"CancelAnimationFrame"]||e[r[t]+"CancelRequestAnimationFrame"];l||(l=function(t){var r=(new Date).getTime(),i=Math.max(0,16-(r-n)),o=e.setTimeout(function(){t(r+i)},i);return n=r+i,o}),c||(c=function(t){e.clearTimeout(t)})}(window),{Controller:r,Scene:i}});

	$(document).ready(function(){

		if($('.lh-sections-wrapper > section').length < 2){
			function checkHeightEl(){
				if($('body.template-page:not(#free-worship-patches)').length > 0){
					var getlh = $('body.template-page').find('.lh-sections-wrapper').outerHeight();

					if(getlh < $(window).height()){
						$('body.template-page').find('.lh-sections-wrapper').addClass('smaller-then-window')
					}else{
						$('body.template-page').find('.lh-sections-wrapper').removeClass('smaller-then-window')
					}
				}
			}
			checkHeightEl();
			$(window).on('resize', function(){
				checkHeightEl();	
			});
		}

//fixed btn on item pages
// if($('body.template-page .custom-section.lh-content .one-more-type-e').length > 0){

// 	var  getBtn = $('body.template-page .custom-section.lh-content .one-more-type-e');
// 	$('body').append(getBtn);
// }

//close announcementBar theme.cache.$announcementBar.length
if($('#shopify-section-announcement-bar').length > 0){
	//console.log(localStorage.getItem('showBar'));
	if(localStorage.getItem('showBar') == 'false'){
		$('#shopify-section-announcement-bar').addClass('hide-bar');
	}else{
		$('#shopify-section-announcement-bar').addClass('show-bar');
	}
	$('#close-announcement').click(function(){
		//console.log(localStorage.getItem('showBar'));
		localStorage.setItem('showBar', 'false');
		$('#shopify-section-announcement-bar').addClass('hide-bar');
	});
}

//active menu btn
$('.highlight-item').on('click', function(){
	$('.highlight-item').not(this).removeClass('active');
	var getSlide = $(this).attr('data-slide');
	$(this).addClass('active')
	$('.body-wrap-inner').removeClass('active')
	$('.image-wrap').removeClass('active')
	$(this).closest('.highlights').find('.highlights-left [data-slide="'+getSlide+'"]').addClass('active');
	$(this).closest('.highlights').find('.images-wrap [data-slide="'+getSlide+'"]').addClass('active');
})
//simulate click on active
if($('body.template-page .tabs-heading .highlight-item').length > 0){
	$('body.template-page .tabs-heading  .highlight-item:nth-child(2)').click();
}

if($('body.template-index').length > 0){
	function setHeaderGap(){
		var margTop = $('.site-header-container').height();

		$('.main-content').css('margin-top', margTop+'px');
	}
	setHeaderGap();

	$(window).resize(function() {
		setHeaderGap();
	});


}
/* scroll */


/* tabs */
$('.tabs-nav-item:nth-child(1)').addClass('active')
$('.tabs-nav-wrapper-inner .tabs-nav-item').on('click', function(){
	var getIndex = $(this).index() + 1;
	var curItem = $(this)
	var curJs = this;

	$(this).closest('.lh-container').find('.tabs-nav-item').removeClass('active');
	$(this).addClass('active');
	$(this).closest('.lh-container').find('.tab-item.active').removeClass('active');
	$(this).closest('.lh-container').find('.tab-item:nth-child('+getIndex+')').addClass('active');
	setTimeout(function(){
		curItem.closest('.lh-container').find('.tab-item .content > *').css('opacity', '0')
		curItem.closest('.lh-container').find('.tab-item:nth-child('+getIndex+') .content > *').css('opacity', '1')
	}, 100);

	if ($(window).width() < 767) {
		var el = curJs.closest('.lh-container')
		el.querySelector('.tabs-wrapper').scrollIntoView({ 
			behavior: 'smooth' 
		});
	}


});

$('.highlights .highlight-item').on('click', function(){
	var curJs = this;
	if ($(window).width() < 767) {
		var el = curJs.closest('.highlights')
		//el.querySelector('.highlights-left').scrollIntoView({ 
			el.querySelector('.highlight-item[data-slide="0"]').scrollIntoView({ 
				behavior: 'smooth' 
			});
		}

	})



if ($('#sound-your-best').length ){

	$('.hero-content .arrow-down').on('click', function(){
			//e.preventDefault();

		})
	var btnBottom = document.querySelector('.hero-content .arrow-down img');
	btnBottom.addEventListener('click', () => {
		document.querySelector('.lh-sections-wrapper > *:nth-child(2)').scrollIntoView({ 
			behavior: 'smooth' 
		});
	});

}


// var simulateClick = function (elem) {
// 	// Create our event (with options)
// 	var evt = new MouseEvent('click', {
// 		bubbles: true,
// 		cancelable: true,
// 		view: window
// 	});
// 	// If cancelled, don't dispatch our event
// 	var canceled = !elem.dispatchEvent(evt);
// };

// 		const btnBottomsecond = document.querySelectorAll('.lh-button .buy-button[href="/scroll"]');
// 		btnBottomsecond.forEach(function(element){
// 			element.addEventListener('click', (e) => {
// 				e.preventDefault();
// 				document.querySelector('.lh-sections-wrapper .plans-container.plans-section-wrapper').scrollIntoView({ 
// 					behavior: 'smooth' 
// 				});
// 			});
// // 			var someLink = this;
// // simulateClick(someLink);
// 		})
$(".lh-button [href='/scroll']").each(function(){
	//$(this).removeAttr('href');
	$(this).attr('data-scroll', '/scroll');
})
$('.lh-button [data-scroll="/scroll"]').each(function(){
	$(this).on('click', function(e) {
		e.preventDefault();
		let $elementToScroll = '';
		if($(".lh-section.description-text-section-wrapper").length > 0){
			$elementToScroll = $(".lh-section.description-text-section-wrapper");
		}else{
			$elementToScroll = $(".plans-container.plans-section-wrapper");
		}
		$([document.documentElement, document.body]).animate({
			scrollTop: $elementToScroll.offset().top
		}, 1000);
	});
})


    // $('.buy-button[href="/scroll"]').on('click', function(e){
    // 	e.preventDefault();
    // 	// $('.lh-sections-wrapper .plans-container.plans-section-wrapper').scrollIntoView({ 
    //  //    behavior: 'smooth' 
    //  //  });
    // })


    /* slider */
    var Swipes = new Swiper('.swiper-container', {
    	loop: true,
    	slidesPerView: 1.3,
    	spaceBetween: 30,
    	freeMode: true,
    	centeredSlides: true,
    	// mousewheel: {
    	// 	//invert: true,
    	// 	forceToAxis: true,
    	// 	releaseOnEdges: true
    	// },
    	navigation: {
    	},
    	pagination: {
    		el: '.swiper-pagination',
    		clickable: true
    	},
    	breakpoints: {
    		640: {
    			slidesPerView: 2.5,
    			spaceBetween: 17
    		},
    		900: {
    			slidesPerView: 3.5
    		}
    	},
    });


    /* play sounds */

    var myAudio = $('.track audio');
    var currentTimeContainer = $('#current-time');
    var totalTimeContainer = $('#total-time');
    var seekSlider = $('#seekslider');
    myAudio.on('loadedmetadata', function() {

    	totalTimeContainer.innerHTML = 	$(this).duration;
    	currentTimeContainer.innerHTML = 	$(this).currentTime;

    });


    function convertElapsedTime(inputSeconds) {
    	var seconds = Math.floor(inputSeconds % 60)
    	if (seconds < 10) {
    		seconds = "0" + seconds
    	}
    	var minutes = Math.floor(inputSeconds / 60)
    	return minutes + ":" + seconds
    }
    $('.track audio').each(function(){
    	var curEl = $(this)
    	var getParent = $(this).closest('.track');
    	curEl.on('canplaythrough', function(e) {

    		var totalTime = e.currentTarget.duration;
    		var currentTimeEl = e.currentTarget.currentTime;

    		totalTimeContainer.innerHTML = 	$(this).duration;
    		currentTimeContainer.innerHTML = 	$(this).currentTime;
    		getParent.find('#total-time').html('/'+convertElapsedTime(totalTime)+'');
    		getParent.find('#current-time').html(convertElapsedTime(currentTimeEl));
    		getParent.find('#seekslider').attr('max', totalTime)
					//getParent.find('#seekslider').max= convertElapsedTime(totalTime);
					getParent.find('#seekslider').attr("value", currentTimeEl);
					getParent.find('#seekslider').val(currentTimeEl);


				})
    	curEl.on('timeupdate', function(e) {
    		var currentTimeEl = e.currentTarget.currentTime;
    		getParent.find('#current-time').html(convertElapsedTime(currentTimeEl));

    		getParent.find('#seekslider').attr("value", currentTimeEl);
    		getParent.find('#seekslider').val(currentTimeEl);
    	})

    })


    myAudio.on('loadedmetadata', function() {
    	totalTimeContainer.innerHTML = convertElapsedTime(myAudio.duration);
    	currentTimeContainer.innerHTML = convertElapsedTime(myAudio.currentTime);
    	seekSlider.max= myAudio.duration;
    	seekSlider.attr("value", myAudio.currentTime);
    });

    myAudio.on('timeupdate', function() {
    	currentTimeContainer.innerHTML = convertElapsedTime(myAudio.currentTime);

    	seekSlider.attr("value", myAudio.currentTime);

    	seekSlider.value = myAudio.currentTime;

    	if (myAudio.ended) {
    		pauseButton.classList.add('display-none');
    		playButton.classList.remove('display-none');
    	}
    });





    /* accordion */
    $('.lh-accordion-item:not(.cols-faq) .lh-header').on('click', function(){
    	$(this).closest('.lh-accordion-item').find('.content').slideToggle();
    	$(this).closest('.lh-accordion-item').toggleClass('active')
    });





    $('.play-btn').on('click', function(){
    	var curItem = $(this);


    	if(curItem.hasClass('playing')){
    		curItem.closest('.track').find('audio')[0].pause();
    		curItem.removeClass('playing');
    		curItem.closest('.track').removeClass('playing')
    	}else{
    		if($('.playing').length > 0){
    			$('.playing audio')[0].pause();
    			$('.playing').removeClass('playing');
    			$('.play-btn.playing').removeClass('playing');
    		}
    		curItem.closest('.track').find('audio')[0].play();
    		curItem.addClass('playing')
    		curItem.closest('.track').addClass('playing')
    	}
    });


    $('.track audio').on('ended', function() {

    	let curItem = $(this);

    	curItem[0].pause();
    	curItem.parent('.track').find('.play-btn').removeClass('playing');
    	curItem.parent('.track').removeClass('playing');

    	if(curItem.closest('.track').next().length > 0){
    		let nextTrack = curItem.closest('.track').next();
    		nextTrack.find('audio')[0].play();
    		nextTrack.find('.play-btn').addClass('playing');
    		nextTrack.addClass('playing');
    	}
    });


    /*mainssstage*/
    $('.sounds-items .subtitle-2.no-video').on('click', function(){
    	document.querySelector('.lh-section.description-text-section-wrapper').scrollIntoView({ 
    		behavior: 'smooth' 
    	});
    });

    $('body .lh-button a, body .lh-btn a').on('click', function(e){
    	if ($(this).attr('href').indexOf("#") >= 0){
    		e.preventDefault();
    		var getAttr = $(this).attr('href').split('#').pop();
    		//console.log(document.querySelector('#'+getAttr));
    		document.querySelector('#'+getAttr).scrollIntoView({ 
    			behavior: 'smooth' 
    		});
    	}

    })


    $('.sounds .video > .container:nth-child(1)').addClass('active-item')
    $('.sounds-items .subtitle-2:not(.no-video)').on('click', function(){
    	/* make video active */
    	var getAttrThis = $(this).attr('data-video');
    	$('.container').removeClass('active-item');
    	$(this).closest('.sounds-container').find('.container[data-video="'+getAttrThis+'"]').addClass('active-item');

    	/*pause all videos except current*/
    	$(".subtitle-2").not(this).addClass('on-hold');
    	$(".subtitle-2").not(this).removeClass('playing');
    	$(".subtitle-2").not(this).each(function(){
    		var curItem = $(this);
    		var getAttrThis = $(this).attr('data-video');
    		if(curItem.hasClass('on-hold')){
    			curItem.closest('.sounds-container').find('.vimeo-video[data-video="'+getAttrThis+'"]').removeClass('playing').vimeo('pause');
    		}else if(curItem.hasClass('playing')){
    			curItem.closest('.sounds-container').find('.vimeo-video[data-video="'+getAttrThis+'"]').addClass('stop').vimeo('pause');
    		}
    	})


    	if($(this).hasClass('on-hold')){

    		$(this).removeClass('on-hold');
    		$(this).addClass('playing');
    		var getAttrThis = $(this).attr('data-video');
    		$(this).closest('.sounds-container').find('.vimeo-video[data-video="'+getAttrThis+'"]').addClass('playing').vimeo('play');

    	}else if($(this).hasClass('playing')){

    		$(this).addClass('on-hold');
    		$(this).removeClass('playing');
    		var getAttrThis = $(this).attr('data-video');
    		$(this).closest('.sounds-container').find('.vimeo-video[data-video="'+getAttrThis+'"]').removeClass('playing').vimeo('pause');

    	}

    })

    /* blog categories */
	// if ( $('#news').length){
	// 	$('.lh-blog-item').each(function(){

	// 		var getCats = $(this).find('.lh-blog--info-wrapper .blog-excerpt table')

	// 		$(this).find('.lh-blog--info-wrapper ').prepend(getCats)
	// 	})

	// }
	if ( $('.elipse-1').length){
		$('.elipse-1').each(function(){

			var curItem = $(this);
			curItem.prepend('<div class="backgrounds"></div>')

		})
	}
	/* remove commas in categiories from blog item */
	$('.template-article .wrap-tags .article-list').contents().filter(function(){
		return (this.nodeType == 3);
	}).remove();


	/* */
	$('[class*="custom-background"], .product-intro-section-wrapper.new.image-in-container').each(function(){

		$(this).closest('section').css({'overflow': 'visible', 'z-index': '1'})
	})
	$('.product-intro-section-wrapper.new.image-in-container').each(function(){

		$(this).closest('section').css({'overflow': 'visible'})
	})

	/* add cart btn on mobile hardware */
	function addCartBtn(){
		if ($(window).width() < 1023) {
			$('.lh-collection-page.hardware-wrapper .custom-btn-add-to-cart').text('');
			$('.lh-collection-page.hardware-wrapper .custom-btn-add-to-cart').addClass('bag-image')
		}else{
			$('.lh-collection-page.hardware-wrapper .custom-btn-add-to-cart').text('ADD TO CART');
			$('.lh-collection-page.hardware-wrapper .custom-btn-add-to-cart').removeClass('bag-image')
		}

	}

	/* anim blocks */
	function activateanim(){
		function anim1(el){

			$(el).each(function(){
				var curEl = $(this);
				var top_of_element = curEl.offset().top;
				var bottom_of_element = curEl.offset().top + curEl.outerHeight();
				var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
				var top_of_screen = $(window).scrollTop();

				if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
					setTimeout(function(){
						curEl.addClass('visible');
					}, 200)


				} else {
					setTimeout(function(){
						curEl.removeClass('visible');
					}, 200)
				}
			});

		}
		function anim2(el){

			$(el).each(function(){
				var curEl = $(this);
				var top_of_element = curEl.offset().top + 150;
				var bottom_of_element = curEl.offset().top + curEl.outerHeight();
				var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
				var top_of_screen = $(window).scrollTop();

				if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
					setTimeout(function(){
						curEl.addClass('visible');
					}, 200)


				} else {
					setTimeout(function(){
						curEl.removeClass('visible');
					}, 200)
				}
			});

		}
		anim1('body section .bottomtotop');
		anim2('body section .toptobottom');
		anim1('body section .fadein');
		anim1('body.template-product .fadein');
		anim1('body.template-product .scale');
		anim1('body.template-product .toptobottom2');
		anim1('body section .bottomtotop2')
		anim1('body section .lefttoright');
		anim1('body section .righttoleft');
		anim1('body footer .scale');
		anim1('body section .toptobottom2');
		anim1('body footer .fadein');
		anim1('.site-header-wrapper #main-header .fadein')
		anim1('body section .scale');
		anim1('body section .slider-container');

		/* only for main background  */
		$('body section .product-intro-section-wrapper > .Index-page-content').each(function(){
			var curEl = $(this);
			var top_of_element = curEl.offset().top ;
			var bottom_of_element = curEl.offset().top + curEl.outerHeight();
			var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
			var top_of_screen = $(window).scrollTop();




			if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
				setTimeout(function(){
					curEl.parent().addClass('visible');
				}, 200)


			} else {
				setTimeout(function(){
					curEl.parent().removeClass('visible');
				}, 200)
			}
		});




	};


	activateanim();

	$(window).scroll(function() {

		activateanim();

	});
	$(window).resize(function() {
		addCartBtn()
	})




	/* end of blocks animations */
	/* tweenmax */
    // Init ScrollMagic Controller
    var scrollMagicController = new ScrollMagic();
    var scrollMagicController2 = new ScrollMagic();
    // Animation will be ignored and replaced by scene value in this example
    var tween = TweenMax.to('#animate', 12, {
    	strokeDashoffset: '1000px'
    });
    var tween1 = TweenMax.to('svg path', 4, {
      // strokeDashoffset: '2100px'
  });
    // Create the Scene and trigger when visible
    var scene = new ScrollScene({
    	triggerElement: '#scene-1',
    	duration: 700 /* How many pixels to scroll / animate */
    })
    .setTween(tween)
    .addTo(scrollMagicController);



    $('.lh-container.versions-wrapper .lh-versions-item-wrapper').each(function(){
    	let getAttr = $(this).find('.lh-btn a').attr('href');


    	if($(this).find('[data-lhlink]').length > 0){
    		getAttr = $(this).find('[data-lhlink]').attr('href');
    	}


		//console.log(getAttr);


		$(this).prepend('<a href="'+getAttr+'" class="link"></a>')
	})


    $('body section [class*="custom-background"]').each(function(){
    	var curItem = $(this);
    	curItem.closest('section').next().children().css({'z-index':'10', 'position': 'relative'})

    })

    function weglotPrepend(){
    	setTimeout(function(){
    		var getWeglot = $('.weglot-container.wg-default');

    		if ($(window).width() < 1025 && $(window).width() > 501) {
    			$('#mobile-header .grid__item.one-third.medium-up--one-sixth.text-right').prepend(getWeglot);

    		}else if ($(window).width() < 500){

    			$('body').prepend(getWeglot);
    		} else if ($(window).width() > 1025){
    			$('#main-header .header-buttons-cols .header-buttons-cols-wrapper').prepend(getWeglot);
    		} 		
    	}, 700)
    }
    weglotPrepend();

    $(window).resize(function() {
    	if ($(window).width() < 1024) {
    		weglotPrepend();
    	}
    	else {
    		weglotPrepend();
    	}
    });

    //if page doesn't have audio 
    if($('.product-inner-wrapper .audio-list').length){

    	if($('.track').length){
    		//console.log('audio track exist');
    	}else{
    		
    		if($('.product-single__description iframe').length){
    			console.log('no audio but video');
    			$('.audio-box-wrapper h6').text('Video Demo');
    			$('.product-inner-wrapper').addClass('video-demo');
    			$('<div class="video-wrapper"></div>').appendTo($('.audio-list'));
    			$('.product-single__description iframe').appendTo($('.audio-list .video-wrapper'));
    		}else{
    			//console.log('no demos');
    			$('.product-inner-wrapper').addClass('no-demos');
    		}
    	}
    }
    



    $('.key-template-cta-section').each(function(){
    	$(this).parent().addClass('key-template-parent-section')
    });

    
    /*anim on loading song specific patch*/
    setTimeout(function(){
    	//$('#song-specific-patch #gf-tree, #song-specific-patch #gf-grid, #sound-libraries #gf-tree, #sound-libraries #gf-grid').css('opacity', '1')
    }, 1000)


    window.addEventListener('globoFilterRenderCompleted', function (e) {
    	setTimeout(function(){
    		
    		$('#gf-tree, #gf-grid, #gf-tree').css('opacity', '1');
    	}, 300);
    });

    if($('.song-specific-product-wrapper').length > 0){
    	$('.song-specific-product-wrapper h6').insertAfter('.product__price');
    }


    function songPatchesCut(){
    	if($('#song-specific-patch').length){
    		var mainArr = [];
    		var author = [];
    		var software = [];

    		var check = setInterval(function() {
    			if ($('.spf-col-12').length) {

    				$('.spf-col-12').each(function(){
    					var curItem = $(this);
    					var getSongStyle = $(this).find('.song-item .song-style p').text();
    					mainArr.push(getSongStyle.split(','));
    				});
    				clearInterval(check);
    			}
    		}, 300);

    		// setTimeout(function(){
    		// 	$('.spf-col-12').each(function(){

    		// 		var curItem = $(this);
    		// 		var getSongStyle = $(this).find('.song-item .song-style p');
    		// 		mainArr.push(getSongStyle);
    		// 		console.log(mainArr);
    		// 		console.log('dasdasdasdas')

    		// 	})
    		// },100)
    	}
    }
    songPatchesCut();

    $('.template-article .lh-banner-wraper').each(function(){
    	// var getSocIcons = $(this).find('.social-block')
    	// $(this).find('.lh-banner .lh-banner-content').append(getSocIcons)
    })

    // $('.lh-comment-list .lh-comment-item').each(function(){
    // 	var getAuthor = $(this).find('.lh-comment-author');
    // 	$(this).find('.lh-comment-image').append(getAuthor)
    // })






})





	/* animations */
	/* Every time the window is scrolled ... */
    // $(window).scroll( function(){

    //     /* Check the location of each desired element */
    //     $('[data-section-id="2haon1owdas"] .lh-item-wrapper').each( function(i){

    //         var bottom_of_object = $(this).position().top + $(this).outerHeight();
    //         var bottom_of_window = $(window).scrollTop() + $(window).height();

    //         /* If the object is completely visible in the window, fade it it */
    //         if( bottom_of_window > bottom_of_object ){

    //             $(this).animate({'opacity':'1'},900);

    //         }

    //     }); 
    
    // });




    if($('.regular-product-wrapper').length){
    	if($('.product-single__description table').length){
    		$('.product-single__description table').each(function(i){
    			$(this).addClass('sunday-table'+i);
    		});
    		// function createAudio(audioSrc, title){
    		// 	$('<div id="track" class="track"><audio src="'+audioSrc+'" type="audio/mpeg" controls="controls"></audio><div class="player-wrapper"><div class="play-btn"></div> <span>'+title+'</span> <div class="time"><div id="seek-container"><input id="seekslider" type="range" min="0" step="1" value=""><div id="seek-values"><div id="current-time"></div><div id="total-time"></div></div></div></div></div></div>').insertAfter('.audio-list');	
    		// };
    		// $('.product-single__description .sunday-table0 tr').each(function(i){
    		// 	var this_src = $(this).find('strong').text(),
    		// 	this_title = $(this).find('em').text();
    		// 	createAudio(this_src, this_title);
    		// });
    		//faq
    		if($('.product-single__description .sunday-table0').length){
    			//create faq section
    			function createFaq(title, content){
    				let faqItem = $('<div class="lh-accordion-item cols-faq bottomtotop "><div class="lh-header" style=""><p class="title">'+title+'</p><span class="arrow"><i class="stt-icon fa"><svg height="14px" width="14px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g fill="#5E6D77"><path d="M12,18.999c-0.4,0-0.776-0.156-1.059-0.438L0.22,7.841C0.078,7.699,0,7.511,0,7.31c0-0.2,0.078-0.389,0.22-0.53c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22L12,17.499L22.72,6.78c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22C23.922,6.922,24,7.11,24,7.31c0,0.2-0.078,0.389-0.22,0.53L13.06,18.56C12.778,18.843,12.401,18.999,12,18.999z"></path></g></svg></i></span></div><div class="content"><div class="content-wrapper-inner">'+content+'</div></div></div>');
    				return faqItem;
    			}
    			//$('.regular-faq-section')

    			$('.product-single__description .sunday-table0 table').each(function(i){
    				$('.lh-accordion-wrapper').append(createFaq($(this).find('tr:nth-child(1) td').html(), $(this).find('tr:nth-child(2) td').html()));
    			});

    			$('.cols-faq .lh-header').on('click', function(){
    				$(this).closest('.lh-accordion-item').find('.content').slideToggle();
    				$(this).closest('.lh-accordion-item').toggleClass('active');
    			});
    		}
    	}
    }


// $('a[href^="#"][href*="youtube"]').click(function(e){
// 	e.preventDefault();
// 	e.stopPropagation();
// 	console.log($(this).attr('href').split('#')[1]);
// 	$(this).magnificPopup({
// 		type: 'iframe',
// 		iframe: {
// 			markup: '<div class="mfp-iframe-scaler">'+
// 			'<div class="mfp-close"></div>'+
// 			'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
//           '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

//           patterns: {
//           	youtube: {
//       index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

//       id: 'v=', // String that splits URL in a two parts, second part should be %id%
//       // Or null - full URL will be returned
//       // Or a function that should return %id%, for example:
//       // id: function(url) { return 'parsed id'; }

//       src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
//   }

//     // you may add here more sources

// },

//   srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
// }
// });
// });



// $('a[href^="#"][href*="youtube"]').click(function(e){
// 	e.preventDefault();
// 	e.stopPropagation();
// });


// $('a[href^="#"][href*="youtube"]').magnificPopup({
// 	type: 'iframe',
// 	iframe: {
// 		markup: '<div class="mfp-iframe-scaler">'+
// 		'<div class="mfp-close"></div>'+
// 			// '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
// 			'<iframe class="mfp-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'+
//           '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

//           patterns: {
//           	youtube: {
//       index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

//       id: '/embed/', // String that splits URL in a two parts, second part should be %id%
//       // Or null - full URL will be returned
//       // Or a function that should return %id%, for example:
//       new_id: function(url) { return url.split('/embed/')[1].split('?')[0] },
//       time: function(url) { return url.split('?')[1] },
//       src: '//www.youtube.com/embed/%id%' // URL that will be set as a source for iframe.
//       //src: '//www.youtube.com/embed/%id%?&autoplay=1&start=100' // URL that will be set as a source for iframe.
//       //src: '//www.youtube.com/embed/%new_id%?autoplay=1&%time%', // URL that will be set as a source for iframe.

//       // в такому форматі працює -- https://www.youtube.com/embed/M7lc1UVf-VE?autoplay=1&start=100"
//   }

//     // you may add here more sources

// },

//   srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
// }
// });



$('a[href^="#"][href*="youtube"], a[href^="#"][href*="youtu.be"]').click(function(e) {
	e.preventDefault();
	e.stopPropagation();
});
$('a[href^="#"][href*="youtube"], a[href^="#"][href*="youtu.be"]').magnificPopup({
	type: 'iframe',
	iframe: {
		markup: '<div class="mfp-iframe-scaler">' +
		'<div class="mfp-close"></div>' +
		'<iframe class="mfp-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
                patterns: {
                	youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
                    //id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    //#https://youtube.com/watch?v=uHpE4P1_jxY&t=55
                    id: function(url) { 
                    	var m = url.split('v=')[1];
                    	if(m.includes('&t=')){
                    		var videoId = m.split('&t=')[0],
                    		timecode = m.split('&t=')[1];
                    		return videoId+'?start='+timecode+'&autoplay=1';
                    	}else{
                    		return m+'?autoplay=1'; 
                    	}
                    	
                    },
                    src: '//www.youtube.com/embed/%id%' // URL that will be set as a source for iframe.
                }
            },
            srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
    });


$('a[href^="#"][href*="vimeo"], a[href^="#"][href*="vimeo"]').each(function(e) {
	// /$(this).attr('href', $(this).attr('href').split('#')[1]);
	//$(this).attr('href', $(this).attr('href').split('#')[1]+'?autoplay=1');

	// console.log( $(this).attr('href'))

	// // $(this).click(function(e) {
	// // 	e.preventDefault();
	// // 	e.stopPropagation();
	// // });


	// $(this).magnificPopup({
	// 	type: 'iframe',
	// 	iframe: {
 //   			markup: '<div class="mfp-iframe-scaler">'+
 //              '<div class="mfp-close"></div>'+
 //              '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
 //            '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
	// 		patterns: {
	// 			vimeo: {
	// 				index: 'vimeo.com/',
	// 				id: '/',
	// 				src: '//player.vimeo.com/video/%id%?autoplay=1'
	// 			}
	// 		},
	// 		srcAction: 'iframe_src' 
	// 	}
	// });


});

$('a[href^="#"][href*="vimeo"], a[href^="#"][href*="vimeo"]').click(function(e) {
	e.preventDefault();
	e.stopPropagation();
});


$('a[href^="#"][href*="vimeo"], a[href^="#"][href*="vimeo"]').magnificPopup({
	type: 'iframe',
	zoom: {
		enabled: false
	},
	iframe: {
		markup: '<div class="mfp-iframe-scaler">' + '<div class="mfp-close"></div>' + '<iframe class="mfp-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' +'</div>', 
		patterns: {
			vimeo: {
				index: 'vimeo.com/',
				id: '/',
				src: '//player.vimeo.com/video/%id%?autoplay=1'
			}
		},
		srcAction: 'iframe_src' 
	}
});




$('a[href^="#img:"]').click(function(e) {
	e.preventDefault();
	e.stopPropagation();
});

$('a[href^="#img:"]').each(function(){
	$(this).attr('data-mfp-src', $(this).attr('href').split('#img:')[1]);
});





$('a[href^="#img:"]').magnificPopup({
	type: 'image',
  tError: '<a href="%url%">The image</a> could not be loaded.' // Error message

});



//https://www.youtube.com/embed/owq5HLIOTkM?start=5



$(document).ready(function(){
	
	if($('.single-option-selector')){

		$('.single-option-selector').niceSelect();
		$('.select-main option').each(function(){
			// console.log('1. '+ $('.nice-select li[data-value="'+$(this).attr('data-value')+'"]').text());
			// console.log('2. '+ $(this).attr('data-value'));
			$(".nice-select li[data-value='"+$(this).attr('data-value')+"']").text($(this).attr('data-value')+' - '+$(this).attr('data-price'));
		});


		$('.nice-select .current').text($('.list .selected').text());
		if($('.selector-wrapper label').text() == 'Version'){
			$('.selector-wrapper > label').text('Choose Product Version');
		}
	}
	$('.view-updates-link a').attr('href', '#updates-popup')


	$('.view-updates-link a').magnificPopup({
		type:'inline',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href. 
    });


});






$(function(){
  	let firstLink = $("#shopify-section-layouthub-60ad17fca4191569ec2955b2 > div > section:nth-child(2) > div > div > div > div > div > div > div.lh-center > div > div:nth-child(2) > div > div > p > a").clone().addClass('firstCloneLink');
  	let firstLinkClass = $("#shopify-section-layouthub-60ad17fca4191569ec2955b2 > div > section:nth-child(2) > div > div > div > div > div > div > div.lh-center > div > div:nth-child(2) > div > div > p ").append(firstLink);

  	let secondLink = $("#shopify-section-layouthub-60ad17fca4191569ec2955b2 > div > section.key-template-parent-section > div > div > div > div > div > div > div.lh-center > div > div:nth-child(3) > div > div > p > a").clone().addClass('secondCloneLink');
  	let secondLinkClass = $("#shopify-section-layouthub-60ad17fca4191569ec2955b2 > div > section.key-template-parent-section > div > div > div > div > div > div > div.lh-center > div > div:nth-child(3) > div > div > p ").append(secondLink);
});




$(function(){
  let bntPosition = $('#PageContainer > div.site-header-wrapper > div > div.action-area > div > div');
  bntPosition.prepend('<a class="bntBack" onclick="javascript:history.back(); return false;"> < Back</a>');
});



// $(function(){
//   $('.aza .qq').on('click',function(e){
//     console.log('azazazaaz');
//     $('.qq').css('display','none');
//     $('#glFilter-search-popup').css('display','none');
//     $('.aza form').addClass('click');
//     $('.aza form').trigger('click');

//    });

// });
  

 $(function(){
   let arrray = $('#shopify-section-search-template > div.grid.grid--uniform.grid--no-gutters > .search-item[data-date]');
   console.log(arrray);
   
   
   
   
 });
